import React, { useState } from 'react';

type TemporaryMessage = string | null;

export enum TemporaryMessageTypes {
  SUCCESS = 'success',
  INFO = 'info',
  ERROR = 'error',
}

const useTemporaryMessage = (): {
  temporaryMessage: TemporaryMessage;
  temporaryMessageType: string;
  setTemporaryMessage: React.Dispatch<React.SetStateAction<TemporaryMessage>>;
  setTemporaryMessageInMs;
} => {
  const [temporaryMessage, setTemporaryMessage] = useState<TemporaryMessage>(null);
  const [temporaryMessageType, setTemporaryMessageType] = useState<TemporaryMessageTypes>(
    TemporaryMessageTypes.INFO
  );

  const setTemporaryMessageInMs = ({
    message,
    displayTimeoutInMs,
    type = TemporaryMessageTypes.INFO,
  }: {
    message: string;
    displayTimeoutInMs: number;
    type?: TemporaryMessageTypes;
  }): void => {
    setTemporaryMessage(message);
    setTemporaryMessageType(type);
    setTimeout(() => setTemporaryMessage(null), displayTimeoutInMs);
  };

  return { temporaryMessage, temporaryMessageType, setTemporaryMessage, setTemporaryMessageInMs };
};

export default useTemporaryMessage;
